import { createTheme } from "@material-ui/core/styles";
import { prestoMuiTheme } from "@prestosports/commons-ui";

const gameMuiTheme = createTheme({
	...prestoMuiTheme,
	palette: {
		...prestoMuiTheme.palette,
		border: {
			primary: "#4c5768"
		},
		gameMode: {
			primary: "#FFFFFF !important",
			secondary: "#767676",
			ternary: "#24A33F"
		},
		teams: {
			home: "#FFFFFF",
			visitor: "#FDAC29"
		},
		menu: {
			backgroundColor: "#202D43",
			item: {
				active: {
					backgroundColor: "#1B2537"
				},
				hover: {
					backgroundColor: "#1B2537"
				}
			}
		},
		container: {
			backgroundColor: "linear-gradient(180deg, #202D43 0%, #0D121C 100%)"
		}
	},
	typography: {
		...prestoMuiTheme.typography,
		h3: {
			fontWeight: 400,
			fontSize: "1.625rem",
			letterSpacing: "-0.0315rem",
			color: "inherit"
		},
		h5: {
			fontFamily: "Overpass",
			fontWeight: "bold",
			fontSize: 18,
			color: "inherit"
		},
		subtitle2: {
			...prestoMuiTheme.typography.body1,
			fontWeight: 600
		}
	}
});

export default gameMuiTheme;
